import { Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class NotificationService {

  constructor(
    private injector: Injector,
  ) { }

  public notify(type: 'info' | 'success' | 'warning' | 'danger' | 'primary', title: string, message = '', from = 'top', align = 'right') {

    const toastr = this.injector.get(ToastrService);

    switch (type) {

      case 'info':
        toastr.info('<span class="now-ui-icons travel_info"></span> ' + message, title, {
          onActivateTick: true,
          timeOut: 8000,
          closeButton: true,
          enableHtml: true,
          toastClass: 'alert alert-info alert-with-icon',
          positionClass: 'toast-' + from + '-' + align
        });
        break;
      case 'success':
        toastr.success('<span class="fas fa-check-circle"></span> ' + message, title, {
          onActivateTick: true,
          timeOut: 8000,
          closeButton: true,
          enableHtml: true,
          toastClass: 'alert alert-success alert-with-icon',
          positionClass: 'toast-' + from + '-' + align
        });
        break;
      case 'warning':
        toastr.warning('<span class="fas fa-exclamation-triangle"></span> ' + message, title, {
          onActivateTick: true,
          timeOut: 8000,
          closeButton: true,
          enableHtml: true,
          toastClass: 'alert alert-warning alert-with-icon',
          positionClass: 'toast-' + from + '-' + align
        });
        break;
      case 'danger':
        toastr.error('<span class="fas fa-circle-exclamation"></span> ' + message, title, {
          onActivateTick: true,
          timeOut: 8000,
          enableHtml: true,
          closeButton: true,
          toastClass: 'alert alert-danger alert-with-icon',
          positionClass: 'toast-' + from + '-' + align
        });
        break;
      case 'primary':
        toastr.show('<span class="fas fa-circle-info"></span> ' + message, title, {
          onActivateTick: true,
          timeOut: 8000,
          closeButton: true,
          enableHtml: true,
          toastClass: 'alert alert-primary alert-with-icon',
          positionClass: 'toast-' + from + '-' + align
        });
        break;
      default:
        break;
    }

  }
}
